import Images from "config/Images";

export interface SignUpWelcomeJsonInterface {
  img: string,
  userType: string,
  description: string
}

export const SignInFlowJson = {
  myself: {
    img: Images.userTypeMyself,
    userType: "Myself",
    description: "Personal account to manage all your activities"
  },
  brand: {
    img: Images.userTypeBrand,
    userType: "Brand",
    description: "Own or belong to a company, this is for you."
  },
  nonProfit: {
    img: Images.userTypeNonprofit,
    userType: "Non-Profit",
    description: "Own or belong to a non-profit, this is for you."
  }
}

export interface SignUpUserType {
  for: string,
  brand: string
}

export const SignUpUserTypeJson = {
  myself: {
    for: "yourself",
    brand: "member"
  },
  brand: {
    for: "brands",
    brand: "brand"
  },
  nonProfit: {
    for: "non profits",
    brand: "non-profit"
  },
  default: {
    for: '',
    brand: ''
  }
}
